import React from "react";

export default {
  page: {
    minHeight: "100vh",
    position: "relative",
    overflow: 'hidden',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(90deg, #fffafc 0%, #ffffff 48%, #f8fbff 100%)",
  } as React.CSSProperties,
  pageGlowLeft: {
    position: "absolute",
    top: "-10px",
    left: "0px",
    width: "260px",
    height: "460px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(75, 201, 241, 1) 4%, rgba(144, 18, 245, 1) 42%, rgba(240, 18, 228, 1) 95%)",
    filter: "blur(220px)",
    pointerEvents: "none",
  } as React.CSSProperties,
  pageGlowRight2: {
    position: "absolute",
    right: "300px",
    bottom: "0px",
    width: "300px",
    height: "260px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(75, 201, 241, 1) 4%, rgba(144, 18, 245, 1) 42%, rgba(240, 18, 228, 1) 95%)",
    filter: "blur(220px)",
    pointerEvents: "none",
  } as React.CSSProperties,
  pageGlowRight1: {
    position: "absolute",
    right: "-180px",
    bottom: "-40px",
    width: "860px",
    height: "860px",
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(197, 227, 255, 0.58) 0%, rgba(220, 234, 255, 0.34) 46%, rgba(255, 255, 255, 0) 74%)",
    filter: "blur(2px)",
    pointerEvents: "none",
  } as React.CSSProperties,
  content: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
  } as React.CSSProperties,
  card: {
    width: "100%",
    maxWidth: "900px",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    border: "1px solid rgba(255, 255, 255, 0.55)",
    borderRadius: "40px",
    overflow: "hidden",
    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.10)",
    backdropFilter: "blur(24px)",
    WebkitBackdropFilter: "blur(24px)",
    display: "flex",
    flexDirection: "column",
  } as React.CSSProperties,
};
